// EditSubject.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDropzone } from "react-dropzone";

const EditSubject = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [picture, setPicture] = useState(null);

  const onDrop = (acceptedFiles) => {
    setPicture(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleCancel = () => {
    navigate("/lessons/subject-details");
  };

  const handleContinue = () => {
    navigate("/lessons/add-topic-form");
  };

  return (
    <div className="p-3 bg-white rounded-lg shadow-lg m-4 h-auto">
      <div className="container mx-auto p-4">
        <h1 className="text-[20px] text-[#400167] font-bold mb-10 ">
          Edit Subject
        </h1>
        <form>
          <div className="mb-10">
            <label className="block text-[16px] text-[#400167] font-semibold mb-4">
              Subject Title
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Write course title"
              className="appearance-none border border-[#400167] rounded w-[683.89px] py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
          <div className="mb-20">
            <label className="block text-[16px] text-[#400167] font-semibold mb-4">
              Subject Overview
            </label>
            <ReactQuill
              value={content}
              onChange={setContent}
              className="w-[683.89px] h-40"
            />
          </div>
          <div className="my-20">
            <label
              className="block text-[#400167] text-[16px] font-semibold mb-2"
              htmlFor="picture"
            >
              Subject Picture
            </label>
            <div
              {...getRootProps({
                className:
                  "border-solid border-2 border-gray-400 rounded py-4 px-4 italic text-[#9E9E9E] cursor-pointer w-[684px]",
              })}
            >
              <input {...getInputProps()} />
              {picture ? <p>{picture.name}</p> : <p>Click to upload</p>}
            </div>
          </div>
          <div className="flex items-center mt-10 gap-8">
            <button
              type="button"
              onClick={handleCancel}
              className="bg-transparent hover:bg-[#5002D0]  text-[#5002D0]  font-semibold hover:text-white py-4 px-4 border border-[#5002D0]  hover:border-transparent rounded-full w-[307px]"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleContinue}
              className="bg-[#5002D0] hover:bg-purple-700 text-white font-bold py-4 px-4 rounded-full w-[307px]"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSubject;
